import React from "react";
import "./buttons.css";

function Gbtn(props) {
  const clr = props.color && props.color ? props.color : "whitesmoke";
  const textClr = props.color ? "white" : "black";
  const radius = props.radius ? props.radius : "";
  const width = props.width ? props.width : "";
  const height = props.height ? props.height : "";
  const defaultFunc = () => {
    console.log("btn with no func!");
  };
  return (
    <>
      <button
        className="btn"
        onClick={props.func ? props.func : defaultFunc}
        disabled={props.disabled}
        style={{
          background: clr,
          color: textClr,
          borderRadius: radius,
          width: width,
          height: height,
        }}
      >
        {props.text}
      </button>
    </>
  );
}

export default Gbtn;
